import axios from "axios";
import {
    authorizationServicesPath,
} from "../../Constants";

const restUrl = authorizationServicesPath + '/admin/organization-rating-indicator'

export default class RatingService {
    static async getAll() {
        return axios.get(restUrl + "/get-all");
    }

    static async update(data, id) {
        return await axios.put(restUrl + "/" + id,
            JSON.stringify(data), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async delete(id) {
        await axios.delete(restUrl + '/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async create(data) {
        return await axios.post(restUrl,
            JSON.stringify(data), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }
}